<template>
  <div>
    <v-layout mb-2 row justify-end>
      <div>
        <span>
          {{ $t("extracurriculares.register.available_courses.help_text") }}
          &nbsp;&nbsp;&nbsp;
        </span>
      </div>
      <div>
        <a @click.prevent.stop="showTerms">
          {{ $t("extracurriculares.pay_reserve.terms_conditions") }}
        </a>
      </div>
    </v-layout>
    <v-container v-if="loading_page" grid-list-xl text-xs-center>
      <v-layout>
        <v-flex>
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card v-if="!coursesAvailable && !loading_page && !showPortfolio">
      <v-layout row wrap justify-center>
        <v-flex xs12 sm6>
          <v-alert type="info" :value="true">
            {{
              $t("extracurriculares.register.available_courses.no_inscriptions")
            }}
          </v-alert>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card>
      <v-layout row wrap justify-center>
        <v-flex
          xs12
          sm8
          py-2
          v-if="payment_type == 'type_payment'"
          v-html="settings.banner_poli"
        ></v-flex>
        <v-flex xs12 sm8 py-2 v-else v-html="settings.banner_extra"></v-flex>
      </v-layout>
    </v-card>
    <v-card v-if="!showPortfolio">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs2>
            <v-select
              v-model="school_filter"
              :items="schools"
              :label="$t('extracurriculares.register.schools')"
              clearable
            ></v-select>
          </v-flex>
          <v-flex xs3>
            <v-select
              v-model="type_filter"
              :items="types"
              :label="$t('extracurriculares.register.course_types')"
              clearable
            ></v-select>
          </v-flex>
          <v-flex xs3>
            <v-text-field
              v-model="search_filter"
              :label="$t('extracurriculares.register.search')"
              clearable
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-select
              v-model="grade_filter"
              :items="grades"
              :label="$t('extracurriculares.register.grades')"
              clearable
            ></v-select>
          </v-flex>
          <v-flex xs2>
            <v-text-field
              v-model="age_filter"
              :label="$t('extracurriculares.register.ages')"
              clearable
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex v-for="course in courses_to_show" :key="course.id" xs3>
            <v-card height="100%">
              <v-img :src="getFirstCourseFile(course.id)" height="150px">
              </v-img>
              <v-card-title>
                <div>
                  <span class="grey--text">{{ course.course_type.name }}</span
                  ><br />
                  <span v-if="locale == 'es'">{{ course.name }}</span>
                  <span v-else>{{ course.eng_name }}</span
                  ><br />
                  <span v-if="course.exclusion_type === 'grade'"
                    ><b
                      >{{ $t("extracurriculares.courses.form.grades") }}:
                      {{ course.grades }}</b
                    ></span
                  >
                  <span v-if="course.exclusion_type === 'next_grade'"
                    ><b
                      >{{ $t("extracurriculares.courses.form.next_grade") }}:
                      {{ course.grades }}</b
                    ></span
                  >
                  <span v-if="course.exclusion_type === 'age'"
                    >{{ $t("extracurriculares.courses.form.ages") }}:
                    {{ course.ages }}</span
                  ><br />
                  <span
                    >{{ $t("extracurriculares.courses.form.price") }}:
                    {{ formatNumber(course.discountprice) }}</span
                  ><br />
                  <!--<span v-if="course.periodicity">{{$t('extracurriculares.courses.form.periodicity')}}: {{ $t(`extracurriculares.courses.form.periodicity_options['${course.periodicity}']`) }}</span><br><br>-->
                  <span
                    class="warning white--text pa-1"
                    mt-1
                    v-if="course.provider_payment == 1"
                  >
                    {{
                      $t(
                        "extracurriculares.register.available_courses.provider_pay"
                      )
                    }}
                  </span>
                  <span
                    class="primary white--text pa-1"
                    mt-1
                    v-if="course.availablequotas <= 0"
                  >
                    {{
                      $t(
                        "extracurriculares.register.available_courses.course_not_added_text"
                      )
                    }}
                  </span>
                </div>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-title>
                <div>
                  <span class="grey--text">{{
                    $t("extracurriculares.courses.schedule")
                  }}</span
                  ><br />
                  <div
                    v-for="(schedule, sh) in course.active_schedules"
                    :key="sh"
                  >
                    <span>{{ sh + 1 }}.</span>
                    <span v-if="locale == 'es'">{{ schedule.name }}</span>
                    <span v-else>{{ schedule.eng_name }}</span>
                  </div>
                </div>
              </v-card-title>
              <v-card-actions>
                <v-card-actions>
                  <v-btn
                    :disabled="course.availablequotas <= 0"
                    :loading="loading_button === course.id"
                    flat
                    outline
                    @click="studentsReserve(course.id)"
                    color="primary"
                    >{{
                      $t("extracurriculares.register.available_courses.add")
                    }}
                  </v-btn>
                  <v-btn
                    flat
                    outline
                    @click="courseDetails(course.id)"
                    color="secondary"
                    >{{
                      $t("extracurriculares.register.available_courses.details")
                    }}</v-btn
                  >
                </v-card-actions>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-alert v-else :value="true" type="info">
      {{ $t("extracurriculares.register.available_courses.portfolio") }}
    </v-alert>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{
            $t(
              "extracurriculares.register.available_courses.course_detail_title"
            )
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              flat
              @click="studentsReserve(course_detail.id)"
              :disabled="course_detail.availablequotas <= 0"
              >{{
                $t("extracurriculares.register.available_courses.add")
              }}</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader>{{
            $t("extracurriculares.register.available_courses.course")
          }}</v-subheader>
          <v-container fluid>
            <v-layout row>
              <v-flex xs3>
                <div class="detail">
                  <span class="detail_title">{{
                    $t("extracurriculares.courses.form.type")
                  }}</span
                  ><br />
                  <span class="detail_text">{{
                    course_detail.course_type.name
                  }}</span>
                </div>
                <div class="detail">
                  <span class="detail_title">{{
                    $t("extracurriculares.courses.form.name")
                  }}</span
                  ><br />
                  <span v-if="locale == 'es'" class="detail_text">{{
                    course_detail.name
                  }}</span>
                  <span v-else class="detail_text">{{
                    course_detail.eng_name
                  }}</span>
                </div>

                <div v-if="course_detail.ages" class="detail">
                  <span class="detail_title">{{
                    $t("extracurriculares.courses.form.ages")
                  }}</span
                  ><br />
                  <span class="detail_text">{{ course_detail.ages }}</span>
                </div>
                <div v-if="course_detail.grades" class="detail">
                  <span class="detail_title">{{
                    $t("extracurriculares.courses.form.grades")
                  }}</span
                  ><br />
                  <span class="detail_text">{{ course_detail.grades }}</span>
                </div>
                <div class="detail">
                  <span class="detail_title">{{
                    $t("extracurriculares.courses.form.price")
                  }}</span
                  ><br />
                  <span class="detail_text"
                    >${{ formatNumber(course_detail.discountprice) }}</span
                  >
                  <span
                    v-if="course_detail.discountprice === 0"
                    class="detail_text"
                  >
                    {{
                      $t(
                        "extracurriculares.register.available_courses.provider_pay"
                      )
                    }}
                  </span>
                </div>
              </v-flex>
              <v-flex xs5 pr-5>
                <div class="detail">
                  <span class="detail_title">{{
                    $t("extracurriculares.courses.form.description")
                  }}</span
                  ><br />
                  <span v-if="locale == 'es'" class="detail_text">{{
                    course_detail.description
                  }}</span>
                  <span v-else class="detail_text">{{
                    course_detail.eng_description
                  }}</span>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
          <div class="course_detail"></div>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>{{
            $t("extracurriculares.register.available_courses.aditional_info")
          }}</v-subheader>
          <v-container fluid>
            <v-layout row>
              <v-flex xs4>
                <v-layout row wrap column>
                  <v-flex 12>
                    <span class="extra_info_title">{{
                      $t(
                        "extracurriculares.register.available_courses.schedules"
                      )
                    }}</span>
                  </v-flex>
                  <v-flex 12>
                    <v-layout row wrap>
                      <v-flex
                        xs6
                        v-for="(schedule, is) in course_detail.active_schedules"
                        :key="is"
                      >
                        <div class="schedule_item">
                          <v-subheader v-if="locale == 'es'">{{
                            schedule.name
                          }}</v-subheader>
                          <v-subheader v-else>{{
                            schedule.eng_name
                          }}</v-subheader>
                          <div
                            v-for="(detail, id) in schedule.details"
                            :key="id"
                            class="schedule_details"
                          >
                            <span class="schedule_day">{{
                              $t(
                                `extracurriculares.courses.schedules.days.${detail.day.substring(
                                  0,
                                  3
                                )}`
                              )
                            }}</span>
                            <span class="schedule_time"
                              >{{ detail.time_from }} -
                              {{ detail.time_to }}</span
                            >
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout mt-3 row wrap column>
                  <v-flex xs12>
                    <span class="extra_info_title">{{
                      $t("extracurriculares.register.available_courses.clothes")
                    }}</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex
                        v-for="(clothe, ic) in course_detail.clothes"
                        :key="ic"
                        xs6
                      >
                        <div class="clothe_item">
                          <div>
                            <v-img
                              :src="
                                clothe.clothe.files.length > 0 &&
                                  clothe.clothe.files[0].file_url
                              "
                              width="100px"
                            ></v-img>
                          </div>
                          <div>
                            <v-subheader class="subheading">
                              <b>{{ clothe.clothe.name }}</b>
                            </v-subheader>
                            <div class="ml-3">
                              {{
                                clothe.clothe.sizes
                                  .map(size => size.size.name)
                                  .join(", ")
                              }}
                            </div>
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs8>
                <v-layout row wrap column v-if="course_detail.teachers.length">
                  <v-flex xs12>
                    <span class="extra_info_title">{{
                      $t(
                        "extracurriculares.register.available_courses.teachers"
                      )
                    }}</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex
                        xs6
                        v-for="(teacher, it) in course_detail.teachers"
                        :key="it"
                      >
                        <div class="teacher_item">
                          <div>
                            <v-img
                              v-if="teacher.teacher.image_url"
                              :src="teacher.teacher.image_url"
                              width="120px"
                              contain
                            ></v-img>
                          </div>
                          <div>
                            <v-subheader>{{
                              teacher.teacher.name
                            }}</v-subheader>
                            <div class="teacher_details">
                              <span class="teacher_attr">{{
                                $t(
                                  "extracurriculares.register.available_courses.schedules"
                                )
                              }}</span
                              >:
                              <span class="teacher_text">{{
                                getSheduleName(
                                  teacher.course_id,
                                  teacher.schedule_id
                                )
                              }}</span
                              ><br />
                              <span class="teacher_attr">{{
                                $t(
                                  "extracurriculares.teachers.form.description"
                                )
                              }}</span
                              >:
                              <span class="teacher_text">{{
                                teacher.teacher.description
                              }}</span
                              ><br />
                              <span class="teacher_attr">{{
                                $t("extracurriculares.teachers.form.email")
                              }}</span
                              >:
                              <span class="teacher_text">{{
                                teacher.teacher.email
                              }}</span
                              ><br />
                            </div>
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>{{
            $t("extracurriculares.register.available_courses.photos_videos")
          }}</v-subheader>

          <div class="photos_videos">
            <v-carousel height="300" class="photos">
              <v-carousel-item
                v-for="(file, i) in course_detail.files.filter(
                  photo => photo.file_type === 'photo'
                )"
                :key="i"
                :src="file.file_url"
              ></v-carousel-item>
            </v-carousel>
            <div class="videos">
              <video
                v-for="(file, i) in course_detail.files.filter(
                  video => video.file_type === 'video'
                )"
                :key="i"
                height="200px"
                width="200px"
                controls
              >
                <source :src="file.file_url" />
              </video>
            </div>
          </div>
        </v-list>
      </v-card>
    </v-dialog>
    <v-dialog v-model="reserve_modal" width="1000px" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ course_name_in_reservation }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-layout ma-1 v-if="!schedules_available" row justify-center>
          <span class="warning white--text pa-1 subheading">{{
            $t(
              "extracurriculares.register.available_courses.course_not_added_text"
            )
          }}</span>
        </v-layout>
        <v-layout pt-3 row justify-center align-center>
          <v-flex xs12>
            <table width="95%">
              <thead>
                <tr>
                  <th>
                    {{
                      $t("extracurriculares.register.available_courses.student")
                    }}
                  </th>
                  <th colspan="2">
                    {{
                      $t(
                        "extracurriculares.register.available_courses.available_schedules"
                      )
                    }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(student, ci) in students.filter(stu => {
                    let pass = true;
                    if (course_data_in_reserv.is_public == 0) {
                      pass = !stu.external;
                    }
                    if (course_data_in_reserv.is_public == 1) {
                      pass = stu.external;
                    }
                    return pass;
                  })"
                  :key="ci"
                >
                  <td width="30%">
                    {{ student.full_name.toUpperCase() }}
                  </td>
                  <td width="20%">
                    <v-select
                      :items="course_schedules"
                      label="Horario"
                      v-model="students_schedule[student.id]"
                      name="schedule_id"
                      multiple
                      v-validate="'required'"
                      @change="validateSchedules(student.id)"
                      :disabled="
                        (studentRestrictions[student.id] &&
                          !studentRestrictions[student.id].available) ||
                          studentPortfolio(student.siesa_sucursal)
                      "
                    ></v-select>
                    <has-error
                      :form="reserveForm"
                      :field="`schedule_${student.id}`"
                    ></has-error>
                  </td>
                  <td>
                    <v-btn
                      :loading="loading_button_student === student.id"
                      @click="
                        addCourse(student.id, student.external, days_to_pay)
                      "
                      color="primary"
                      :disabled="
                        (studentRestrictions[student.id] &&
                          !studentRestrictions[student.id].available) ||
                          courseReserved(student.id) ||
                          loading_button_student === student.id ||
                          shcedulesValidations[students_schedule[student.id]] ||
                          studentPortfolio(student.siesa_sucursal)
                      "
                    >
                      <span v-if="courseReserved(student.id)">{{
                        $t("extracurriculares.register.available_courses.added")
                      }}</span>
                      <span
                        v-else-if="
                          registeredType(
                            student,
                            course_data_in_reserv.course_type_id
                          )
                        "
                        >{{
                          $t("extracurriculares.register.available_courses.add")
                        }}</span
                      >
                      <span v-else-if="days_to_pay == 0">{{
                        $t("extracurriculares.register.available_courses.pay")
                      }}</span>
                      <span v-else>{{
                        $t("extracurriculares.register.available_courses.add")
                      }}</span>
                    </v-btn>
                  </td>
                  <td>
                    <div v-if="studentPortfolio(student.siesa_sucursal)">
                      <v-alert
                        :value="true"
                        type="warning"
                        outline
                        class="ml-4"
                      >
                        {{
                          $t(
                            "extracurriculares.register.available_courses.portfolio"
                          )
                        }}
                      </v-alert>
                    </div>
                    <div
                      v-else-if="
                        (studentRestrictions[student.id] &&
                          !studentRestrictions[student.id].available) ||
                          shcedulesValidations[students_schedule[student.id]]
                      "
                    >
                      <v-alert
                        :value="true"
                        type="warning"
                        outline
                        class="ml-4"
                      >
                        <ul>
                          <li
                            v-if="
                              studentRestrictions[student.id] &&
                                studentRestrictions[student.id].grade
                            "
                          >
                            {{
                              $t(
                                "extracurriculares.register.available_courses.grade_requirement"
                              )
                            }}
                          </li>

                          <li
                            v-if="
                              studentRestrictions[student.id] &&
                                studentRestrictions[student.id].age
                            "
                          >
                            {{
                              $t(
                                "extracurriculares.register.available_courses.age_requirement"
                              )
                            }}
                          </li>
                          <li
                            v-if="
                              studentRestrictions[student.id] &&
                                studentRestrictions[student.id].prerequisite
                            "
                          >
                            {{
                              $t(
                                "extracurriculares.register.available_courses.course_requirement"
                              )
                            }}
                          </li>
                          <li
                            v-if="
                              shcedulesValidations[
                                students_schedule[student.id]
                              ]
                            "
                          >
                            {{
                              $t(
                                "extracurriculares.register.available_courses.schedule_requirement"
                              )
                            }}
                          </li>
                        </ul>
                      </v-alert>
                    </div>
                    <div
                      v-else-if="
                        days_to_pay == 0 &&
                          !registeredType(
                            student,
                            course_data_in_reserv.course_type_id
                          )
                      "
                    >
                      <v-alert
                        :value="true"
                        type="warning"
                        outline
                        class="ml-4"
                      >
                        Al dar click en Pagar, estás aceptando nuestros
                        <a
                          href="/app/storage/extracurriculares/terms.pdf"
                          target="_blank"
                          >términos y condiciones</a
                        >.
                      </v-alert>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>
        <v-layout row justify-center align-center>
          <v-btn color="primary" @click="reserve_modal = false">
            {{ $t("close") }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="terms_dialog"
      max-width="600px"
      transition="dialog-transition"
    >
      <terms v-on:closeTerms="terms_dialog = false"></terms>
    </v-dialog>
    <v-dialog v-model="payment_dialog" width="600" persistent>
      <v-card>
        <v-card-title class="headline primary white--text" primary-title>
          {{ $t("payments.payment_text_title") }}
        </v-card-title>

        <v-card-text v-html="$t('payments.payment_text')"> </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Form from "vform";
import { mapGetters } from "vuex";
import terms from "./terms";
export default {
  name: "extracurriculares-reserve-view",
  components: {
    terms: terms
  },
  data() {
    return {
      terms_dialog: false,
      courses: [],
      courses_to_show: [],
      dialog: false,
      payment_dialog: false,
      course_detail: {
        course_type: {},
        files: [],
        teachers: []
      },
      showPortfolio: false,
      reservations: [],
      loading_button: 0,
      loading_button_student: 0,
      loading_page: true,
      schools: [
        { value: "k4,k5,1", text: "Preschool" },
        { value: "2,3,4,5", text: "Elementary School" },
        { value: "6,7,8", text: "Middle School" },
        { value: "9,10,11,12", text: "High School" }
      ],
      types: [],
      school_filter: "",
      type_filter: "",
      search_filter: "",
      grade_filter: "",
      age_filter: "",
      registration_ids: [],
      days_to_pay: "",
      students: [],
      reserve_modal: false,
      course_in_reservation: null,
      studentRestrictions: {},
      course_name_in_reservation: "",
      course_data_in_reserv: {},
      course_schedules: [],
      students_schedule: {},
      schedules_available: true,
      reserveForm: new Form({}),
      grades: [],
      shcedulesValidations: {},
      portfolio: [],
      payment_type: null,
      settings: {}
    };
  },
  created() {
    this.payment_type = this.$route.params.type;
    this.getCourses();
  },

  computed: {
    // "$route.params.type": function(newType, oldType) {
    //   // this.reset();
    //   this.payment_type = newType;
    //   this.getCourses();
    // },
    coursesAvailable() {
      return this.courses.length > 0;
    },
    ...mapGetters({
      locale: "locale"
    })
  },
  watch: {
    "$route.params.type": function(newType, oldType) {
      this.reset();
      this.payment_type = newType;
      this.getCourses();
      this.coursesAvailable();

    },
    reserve_modal(newValue, oldValue) {
      if (!newValue) {
        this.course_in_reservation = null;
      }
    },
    school_filter(newValue, oldValue) {
      this.filter_courses();
    },
    type_filter(newValue, oldValue) {
      this.filter_courses();
    },
    search_filter(newValue, oldValue) {
      this.filter_courses();
    },
    grade_filter(newValue, oldValue) {
      this.filter_courses();
    },
    age_filter(newValue, oldValue) {
      this.filter_courses();
    }
  },
  methods: {
    reset() {
      this.terms_dialog = false;
      this.courses = [];
      this.courses_to_show = [];
      this.dialog = false;
      this.payment_dialog = false;
      this.course_detail = {
        course_type: {},
        files: [],
        teachers: []
      };
      this.showPortfolio = false;
      this.reservations = [];
      this.loading_button = 0;
      this.loading_button_student = 0;
      this.loading_page = true;
      this.schools = [
        { value: "k4,k5,1", text: "Preschool" },
        { value: "2,3,4,5", text: "Elementary School" },
        { value: "6,7,8", text: "Middle School" },
        { value: "9,10,11,12", text: "High School" }
      ];
      this.types = [];
      this.school_filter = "";
      this.type_filter = "";
      this.search_filter = "";
      this.grade_filter = "";
      this.age_filter = "";
      this.registration_ids = [];
      this.days_to_pay = "";
      this.students = [];
      this.reserve_modal = false;
      this.course_in_reservation = null;
      this.studentRestrictions = {};
      this.course_name_in_reservation = "";
      this.course_data_in_reserv = {};
      this.course_schedules = [];
      this.students_schedule = {};
      this.schedules_available = true;
      this.reserveForm = new Form({});
      this.grades = [];
      this.shcedulesValidations = {};
      this.portfolio = [];
      this.settings = {};
    },
    getCourses() {
      var api_url = "/api/extracurriculares/courses_available";
      if (this.payment_type) {
        api_url = api_url + "/" + this.payment_type;
      }

      axios
        .get(api_url)
        .then(resp => {
          if (resp.status === 200) {
            const { data } = resp;

            if (data.available_courses) {
              this.portfolio = data.portfolio;
              this.courses = data.courses;
              this.courses_to_show = data.courses;
              this.reservations = resp.data.reservations;
              this.registration_ids = resp.data.registration_ids;
              this.registration_ids = resp.data.registration_ids;
              this.students = resp.data.students.concat(
                resp.data.studentsExt.map(extEst => ({
                  grade_level: 0,
                  next_grade: 0,
                  age: extEst.age,
                  approved_courses: [],
                  active_reservations: extEst.active_reservations,
                  id: `E-${extEst.id}`,
                  external: true,
                  full_name: `${extEst.full_name}`,
                  registered_types: []
                }))
              );

              if (this.course_in_reservation) {
                this.studentsReserve(this.course_in_reservation);
              }
              this.courses.forEach(course => {
                var existingValue = this.types.find(
                  type => type.value === course.course_type.id
                );
                if (!existingValue) {
                  this.types.push({
                    value: course.course_type.id,
                    text: course.course_type.name
                  });
                }
              });
              console.log(JSON.stringify(this.types));
            }
            this.loading_button = 0;
            this.loading_button_student = 0;
            this.loading_page = false;
          }
        })
        .catch(error => {
          this.loading_page = false;
        });

      /*axios.get('/api/extracurriculares/course_types')
        .then(resp => {
          if (resp.status == 200) {
            resp.data
            .filter(course_type => course_type.status == 1)
            .forEach(course_type => {
              this.types.push(
                { value: course_type.id, text: course_type.name }
              )
            });
          }
        })*/

      axios.get("/api/school_grades").then(resp => {
        if (resp.status === 200) {
          resp.data.map(grade =>
            this.grades.push({ value: grade.name, text: grade.name })
          );
        }
      });

      axios.get("/api/extracurriculares/settings").then(resp => {
        if (resp.status === 200) {
          this.settings = resp.data;
        }
      });
    },
    studentPortfolio(student_sucursal) {
      return (
        this.portfolio.filter(value => value.id_sucursal == student_sucursal)
          .length > 0
      );
    },
    getFirstCourseFile(id) {
      let files = this.courses
        .filter(course => course.id === id)
        .map(course => course.files)[0]
        .filter(file => file.file_type === "photo");

      if (files.length === 0) {
        return "";
      }

      return files[0].file_url;
    },
    courseDetails(id) {
      this.dialog = true;
      this.course_detail = this.courses.find(course => course.id === id);
    },
    studentsReserve(course_id) {
      this.reserve_modal = true;
      this.course_in_reservation = course_id;
      this.studentRestrictions = {};
      this.days_to_pay = this.registration_ids.find(
        days => days.course_id === course_id
      ).days_to_pay;
      const course = this.courses.find(course => course.id === course_id);
      this.course_schedules = [];
      this.students_schedule = {};
      let available_schedule;
      course.active_schedules.forEach(schedule => {
        available_schedule = course.quota <= schedule.quotasregistered;
        this.course_schedules.push({
          value: schedule.id,
          text: `${schedule.name} ${
            available_schedule
              ? `(${this.$t(
                  "extracurriculares.register.available_courses.no_quota"
                )})`
              : ""
          }`,
          disabled: available_schedule
        });
      });

      this.schedules_available = this.course_schedules.length > 0;

      this.course_name_in_reservation = course.name;
      this.course_data_in_reserv = course;
      this.students.forEach(student => {
        let available = true;
        let grade = false;
        let age = false;
        let prerequisite = false;

        if (course.exclusion_type === "grade" && course.grades) {
          available = course.grades.split(", ").includes(student.grade_level);
          grade = !available;
        }

        if (course.exclusion_type === "next_grade" && course.grades) {
          available = course.grades.split(", ").includes(student.next_grade);
          grade = !available;
        }

        if (course.exclusion_type === "age" && course.ages) {
          const ages = course.ages.split(" - ").map(age => parseInt(age, 10));
          available = student.age >= ages[0] && student.age <= ages[1];
          age = !available;
        }

        if (course.prerequisite_id) {
          const prerequisite_approved =
            student.approved_courses &&
            student.approved_courses.filter(
              course => course.course_id === course.prerequisite_id
            ).length > 0;

          available = prerequisite_approved;
          prerequisite = !prerequisite_approved;
        }

        this.studentRestrictions[student.id] = {
          available,
          grade,
          age,
          prerequisite
        };
      });
    },
    addCourse(student_id, external, days_to_pay) {
      this.loading_button_student = student_id;
      this.dialog = false;
      const course_id = this.course_in_reservation;
      const schedule_id = this.students_schedule[student_id];
      let type = "";
      if (!schedule_id) {
        this.reserveForm.errors.set({
          [`schedule_${student_id}`]: "Debe seleccionar un horario"
        });
        this.loading_button_student = 0;
        return;
      }
      if (
        this.course_data_in_reserv.course_type.payment_type == "course_payment"
      ) {
        type = "course";
      } else {
        type = "type";
      }

      this.loading_button = course_id;
      const registration_id = this.registration_ids.find(
        registration => registration.course_id == course_id
      ).registration_id;
      axios
        .post("/api/extracurriculares/registration/reserve", {
          course_id,
          registration_id,
          student_id,
          schedule_id,
          stu_type: external ? "1" : "0"
        })
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.reserved) {
              if (this.course_data_in_reserv.finalprice > 0) {
                if (days_to_pay == 0 && !resp.data.already_registered) {
                  axios
                    .post(`/api/extracurriculares/registration/pay/ptp`, {
                      type: type,
                      id: resp.data.reservation_id,
                      total: this.course_data_in_reserv.discountprice,
                      student_id: student_id,
                      course_type_id: this.course_data_in_reserv.course_type_id,
                      external: external ? true : false
                    })
                    .then(resp => {
                      if (resp.status === 200) {
                        if (resp.data.error) {
                          this.$store.dispatch("responseMessage", {
                            type: "error",
                            text: resp.data.message,
                            title: this.$t("error_alert_text"),
                            modal: true
                          });
                          this.loading_button = 0;
                          return;
                        }
                        this.payment_dialog = true;
                        setTimeout(() => {
                          // this.payment_dialog = false;
                          window.location = resp.data.url;
                        }, 5000);
                      } else {
                      }
                      this.loading_button = 0;
                    })
                    .catch(error => {
                      this.$store.dispatch("responseMessage", {
                        type: "error",
                        text: this.$t(
                          "extracurriculares.pay_reserve.payment_error"
                        ),
                        title: this.$t("error_alert_text"),
                        modal: true
                      });
                      this.loading_button = 0;
                      console.log(error);
                    });
                } else if (resp.data.already_registered) {
                  this.$store.dispatch("responseMessage", {
                    type: "success",
                    text: this.$t(
                      "extracurriculares.register.available_courses.course_added_text_no_pay"
                    ),
                    modal: true
                  });
                } else {
                  this.$store.dispatch("responseMessage", {
                    type: "success",
                    text: this.$t(
                      "extracurriculares.register.available_courses.course_added_text",
                      {
                        days: resp.data.days_to_pay,
                        hours: resp.data.days_to_pay * 24
                      }
                    ),
                    modal: true
                  });
                }
              } else {
                this.$store.dispatch("responseMessage", {
                  type: "success",
                  text: this.$t(
                    "extracurriculares.register.available_courses.course_added_text_no_pay"
                  ),
                  modal: true
                });
              }
              this.getCourses();
              // this.reservations.push({course_id})
              return;
            } else if (resp.data.other_schedules) {
              this.loading_button = 0;
              this.loading_button_student = 0;

              this.$store.dispatch("responseMessage", {
                type: "warning",
                text: `${this.$t(
                  "extracurriculares.register.available_courses.schedule_in_another_course"
                )} (${resp.data.other_schedules}): ${resp.data.detail}`,
                modal: true
              });
            } else {
              this.loading_button = 0;
              this.loading_button_student = 0;

              this.$store.dispatch("responseMessage", {
                type: "warning",
                text: this.$t(
                  "extracurriculares.register.available_courses.course_not_added_text"
                ),
                modal: true
              });
            }
          }
        })
        .catch(error => {
          this.loading_button_student = 0;
          this.loading_button = 0;
        });
    },
    getSheduleName(course_id, schedule_id) {
      const schedule = this.course_detail.active_schedules.find(
        schedule =>
          schedule.course_id == course_id && schedule.id == schedule_id
      );
      return schedule ? schedule.name : "";
    },
    formatNumber(number) {
      if (!number || typeof number === "undefined") {
        return 0;
      } else {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    filter_courses() {
      let courses_to_show = this.courses;

      if (this.type_filter && this.type_filter !== "") {
        courses_to_show = courses_to_show.filter(
          course => course.course_type.id === this.type_filter
        );
      }

      if (this.search_filter && this.search_filter.trim() !== "") {
        courses_to_show = courses_to_show.filter(
          course =>
            course.name
              .toUpperCase()
              .indexOf(this.search_filter.toUpperCase()) > -1
        );
      }

      if (this.school_filter && this.school_filter !== "") {
        let course_grades = [];
        let pass_filter = false;
        courses_to_show = courses_to_show.filter(course => {
          pass_filter = false;
          course_grades =
            course.grades &&
            course.grades.split(",").map(f => parseInt(f.trim(), 10));
          this.school_filter
            .split(",")
            .map(f => parseInt(f.trim(), 10))
            .map(f => {
              if (course_grades && course_grades.includes(f)) {
                pass_filter = true;
              }
            });
          return pass_filter;
        });
      }

      if (this.grade_filter && this.grade_filter !== "") {
        let course_grades = [];
        let pass_filter = false;
        courses_to_show = courses_to_show.filter(course => {
          pass_filter = false;
          course_grades =
            course.grades && course.grades.split(",").map(f => f.trim());
          if (!course_grades) {
            pass_filter = true;
          } else {
            if (course_grades.includes(this.grade_filter)) {
              pass_filter = true;
            }
          }
          return pass_filter;
        });
      }

      if (this.age_filter && this.age_filter !== "") {
        let course_ages = [];
        let pass_filter = false;
        courses_to_show = courses_to_show.filter(course => {
          pass_filter = false;
          course_ages =
            course.ages &&
            course.ages.split("-").map(f => parseInt(f.trim(), 10));

          if (!course_ages) {
            pass_filter = true;
          } else if (
            course_ages[0] <= this.age_filter &&
            this.age_filter <= course_ages[1]
          ) {
            pass_filter = true;
          }
          return pass_filter;
        });
      }

      this.courses_to_show = courses_to_show;
    },
    courseReserved(student_id) {
      // let reserved = false
      if (this.students_schedule[student_id]) {
        return (
          this.students
            .find(student => student.id == student_id)
            .active_reservations.filter(
              reservation =>
                reservation.course_id == this.course_in_reservation &&
                this.students_schedule[student_id].includes(
                  reservation.schedule_id
                )
            ).length > 0
        );
      } else {
        return false;
      }
    },
    registeredType(student, course_type_id) {
      if (
        student.registered_types.length > 0 &&
        student.registered_types.filter(
          type => type.course_type_id == course_type_id
        ).length > 0
      ) {
        return true;
      }
      return false;
    },
    validateSchedules(student_id) {
      const student_schedule = this.students_schedule[student_id];
      this.shcedulesValidations = {};
      this.students_schedule = {};
      this.students_schedule[student_id] = student_schedule;

      const course_id = this.course_in_reservation;
      const course = this.courses.find(course => course.id === course_id);
      if (!course.no_validation) {
        const schedule_to_validate_details = this.courses
          .find(course => course.id === course_id)
          .active_schedules.find(schedule =>
            this.students_schedule[student_id].includes(schedule.id)
          ).details;

        this.students
          .find(student => student.id === student_id)
          .active_reservations.forEach(reservation => {
            reservation.schedule.details.forEach(reservation_detail => {
              schedule_to_validate_details
                .filter(
                  schedule_to_validate =>
                    schedule_to_validate.day === reservation_detail.day
                )
                .forEach(validation_detail => {
                  if (
                    (Date.parse(
                      `1990-01-01 ${validation_detail.time_from}:00`
                    ) >=
                      Date.parse(
                        `1990-01-01 ${reservation_detail.time_from}:00`
                      ) &&
                      Date.parse(
                        `1990-01-01 ${validation_detail.time_from}:00`
                      ) <=
                        Date.parse(
                          `1990-01-01 ${reservation_detail.time_to}:00`
                        )) ||
                    (Date.parse(`1990-01-01 ${validation_detail.time_to}:00`) >=
                      Date.parse(
                        `1990-01-01 ${reservation_detail.time_from}:00`
                      ) &&
                      Date.parse(
                        `1990-01-01 ${validation_detail.time_to}:00`
                      ) <=
                        Date.parse(
                          `1990-01-01 ${reservation_detail.time_to}:00`
                        )) ||
                    (Date.parse(
                      `1990-01-01 ${reservation_detail.time_from}:00`
                    ) >=
                      Date.parse(
                        `1990-01-01 ${validation_detail.time_from}:00`
                      ) &&
                      Date.parse(
                        `1990-01-01 ${reservation_detail.time_from}:00`
                      ) <=
                        Date.parse(
                          `1990-01-01 ${validation_detail.time_to}:00`
                        )) ||
                    (Date.parse(
                      `1990-01-01 ${reservation_detail.time_to}:00`
                    ) >=
                      Date.parse(
                        `1990-01-01 ${validation_detail.time_from}:00`
                      ) &&
                      Date.parse(
                        `1990-01-01 ${reservation_detail.time_to}:00`
                      ) <=
                        Date.parse(
                          `1990-01-01 ${validation_detail.time_to}:00`
                        ))
                  ) {
                    this.shcedulesValidations[
                      validation_detail.schedule_id
                    ] = true;
                  }
                });
            });
          });
      }
    },
    showTerms() {
      this.terms_dialog = true;
    }
  }
};
</script>
<style>
.course_detail {
  display: flex;
  justify-content: space-around;
  padding: 10px;
}
.detail_title {
  font-weight: 600;
}
.photos_videos {
  display: flex;
  justify-content: space-around;
}
.photos {
  margin: 15px;
  width: 40%;
}
.videos {
  margin: 15px;
  display: flex;
  flex-wrap: wrap;
  width: 60%;
}

.videos video {
  margin: 10px;
}

.extra_info_title {
  font-weight: 600;
  font-size: 15px;
  background-color: #bbdefb;
  width: 50%;
  padding: 5px 25px;
}

.schedule {
  display: flex;
}

.schedule_item {
  border: 1px solid lightgrey;
  margin-right: 10px;
  margin-top: 15px;
  padding: 2px;
  display: flex;
  flex-direction: column;
}

.schedule_details {
  margin-left: 15px;
  display: flex;
  flex-direction: column;
}

.schedule_day {
  font-weight: 500;
}

.schedule_time {
  opacity: 0.8;
}

.teacher_item {
  border: 1px solid lightgrey;
  margin-right: 10px;
  margin-top: 15px;
  padding: 15px;
  display: flex;
  align-items: flex-end;
}

.clothe_item {
  border: 1px solid lightgrey;
  margin-right: 2px;
  margin-top: 5px;
  padding: 5px;
  display: flex;
  align-items: center;
}

.teacher_details {
  margin-left: 15px;
}

.teacher_attr {
  font-weight: 500;
}

.teacher_text {
  opacity: 0.8;
}

.clothes_detail {
  margin-left: 15px;
  margin-top: 10px;
}

table,
tr {
  border: 1px solid lightgray;
  padding: 10px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/enrollment/reserve.vue